// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"ProductDetails_imageWrapper__24-qi","image":"ProductDetails_image__2Rx9w","contentWrapper":"ProductDetails_contentWrapper__1KIrF"};